import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { getCategoryDetails } from "store/actions/categoriesAction"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"
import { getGiftCardDetails } from "store/actions/giftCardAction"
import formatDateTime from "components/Shared/formatDateTime"
import { hasExpired, hasStarted } from "common/utils"

const GiftCardDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Eidiyah Details | Namq")
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, giftCardDetails } = useSelector(state => state.GiftCard)

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    dispatch(getGiftCardDetails(id))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        {loading ? (
          <Card>
            <CardBody>
              <Row>
                <Col lg={8}>
                  <ShimmerThumbnail height={600} rounded />
                </Col>
                <Col lg={4}>
                  <ShimmerThumbnail height={600} rounded />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 d-flex align-items-center">
                    <BackButton /> {t("Eidiyah Details")}
                  </CardTitle>
                  <div className="table-responsive">
                    {Object.values(giftCardDetails).length === 0 ? (
                      <p className="text-center">
                        {t("No gift card details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{giftCardDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(English)")}</th>
                            <td>{giftCardDetails.name || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(عربي)")}</th>
                            <td>{giftCardDetails.nameAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {giftCardDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Description(English)")}</th>
                            <td className="text-wrap">
                              {giftCardDetails.description || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Description(عربي)")}</th>
                            <td className="text-wrap">
                              {giftCardDetails.descriptionAr || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Amount")}</th>
                            <td>{giftCardDetails.amount ?? "-"} SAR</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Total Purchased")}</th>
                            <td>{giftCardDetails.totalPurchased ?? "-"}</td>
                          </tr>
                          {/* <tr>
                            <th scope="row">{t("Starts At")}</th>
                            <td>
                              <p
                                className={`mb-0 ${
                                  hasStarted(giftCardDetails.startsAt)
                                    ? "text-success"
                                    : ""
                                }`}
                              >
                                {formatDateTime(giftCardDetails.startsAt) ||
                                  "-"}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Expires At")}</th>
                            <td>
                              <p
                                className={`mb-0 ${
                                  hasExpired(giftCardDetails.expiresAt)
                                    ? "text-danger"
                                    : ""
                                }`}
                              >
                                {formatDateTime(giftCardDetails.expiresAt) ||
                                  "-"}
                              </p>
                            </td>
                          </tr> */}
                          <tr>
                            <th scope="row">{t("Created By Name")}</th>
                            <td>
                              {giftCardDetails?.createdBy?.username || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Created By Email")}</th>
                            <td>{giftCardDetails?.createdBy?.email || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Created At")}</th>
                            <td>
                              {formatDateTime(giftCardDetails.createdAt) || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Updated At")}</th>
                            <td>
                              {formatDateTime(giftCardDetails.updatedAt) || "-"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="">
                <CardBody>
                  {giftCardDetails.imageUrl && (
                    <img
                      src={giftCardDetails.imageUrl}
                      alt="gift card"
                      className="img-fluid d-block mx-auto"
                      style={{ height: "100%", objectFit: "contain" }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default GiftCardDetails
